import {reduxForm, Field} from 'redux-form'
import {connect} from 'react-redux'
import DropdownOutlet from 'components/Fields/ReduxForm/DropdownOutlet'
import styles from './ActionBar.css'

class ActionBar extends React.Component {
  render () {
    const {outlets} = this.props
    return (<div className={styles['action-bar']}>
      <Field
        component={DropdownOutlet}
        outlets={outlets}
        onChangeOutletIds={this._onChangeOutlet}
        name='outlet'
      />
    </div>)
  }

  _onChangeOutlet = (outletIds) => {
    this.props.onChangeOutlet(outletIds)
  };
}

const mapForm = {
  form: 'search'
}

function mapStateToProps (state) {
  return {
    outlets: state.setting.receipt.outlets
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

ActionBar.propTypes = {
  onChangeOutlet: React.PropTypes.func
}
export default reduxForm(mapForm)(connect(mapStateToProps, mapDispatchToProps)(ActionBar))



// WEBPACK FOOTER //
// ./app/pages/AccountSetting/Receipt/ActionBar/ActionBar.js